import {saveAs} from 'file-saver';
import XLSX from 'sheetjs-style';

const STYLED = Symbol('styled');
export const styledCell = (value, style) => ({ [STYLED]: true, value, style });

export const saveExcel = async (inputData, filename, columnMeta = [], styleCell = null) => {
	filename = filename.replaceAll(/[\\/?*[\]]/g, '_');

	// Extract inline styles, produce a clean 2D array of raw values
	const inlineStyles = [];
	const cleanData = inputData.map((row, r) =>
		row.map((cell, c) => {
			if (cell && typeof cell === 'object' && cell[STYLED]) {
				inlineStyles.push({ r, c, style: cell.style });
				return cell.value;
			}
			return cell;
		})
	);

	const WS = XLSX.utils.aoa_to_sheet(cleanData, { cellDates: true });
	const range = XLSX.utils.decode_range(WS['!ref']);

	// Column widths / hidden
	if (columnMeta.length) {
		WS['!cols'] = columnMeta.map(m => {
			if (!m) return {};
			const col = {};
			if (m.width != null) col.wch = m.width;
			if (m.hidden) col.hidden = true;
			return col;
		});
	}

	// Apply inline styles on top, deep-merging the common sub-objects
	for (const { r, c, style } of inlineStyles) {
		const cell = WS[XLSX.utils.encode_cell({ r, c })];
		if (!cell) continue;
		cell.s = {
			...(cell.s || {}),
			...style,
			font: { ...(cell.s?.font || {}), ...(style.font || {}) },
			fill: { ...(cell.s?.fill || {}), ...(style.fill || {}) },
			alignment: { ...(cell.s?.alignment || {}), ...(style.alignment || {}) },
			border: { ...(cell.s?.border || {}), ...(style.border || {}) },
		};
	}

	// Per-cell callback
	if (styleCell) {
		for (let r = range.s.r; r <= range.e.r; r++) {
			for (let c = range.s.c; c <= range.e.c; c++) {
				const cell = WS[XLSX.utils.encode_cell({ r, c })];
				if (!cell) continue;
				const value = cleanData[r] ? cleanData[r][c] : undefined;
				styleCell(cell, { row: r, col: c, value });
			}
		}
	}

	const wb = { Sheets: { [filename]: WS }, SheetNames: [filename] };
	const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
	const data = new Blob([excelBuffer], {
		type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
	});
	saveAs(data, filename + '.xlsx');
};
